module.exports = __webpack_public_path__ + "static/img/相册.ddcf0cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobilPhoneShell3d/imgs/相册.png
// module id = 5IYP
// module chunks = 2